/**
 * 홈 화면 메인 배너 목록 조회. 무인증 비동기 함수(SWR 훅이 아니다).
 * `GET /app/banner/main`
 *
 * @returns 응답 전체(`FetchBannerMainResponse`) 또는 실패 시 null.
 */
import publicApi from "pages/api/axiosPublic";

export interface BannerItem {
  bannerId: number;
  url: string;
  imageUrl: string;
}

interface FetchBannerMainResponse {
  isSuccess: boolean;
  code: number;
  message: string;
  result: BannerItem[];
}

export const useGetBannerMain =
  async (): Promise<FetchBannerMainResponse | null> => {
    try {
      const response = await publicApi.get<FetchBannerMainResponse>(
        "/app/banner/main"
      );
      return response.data;
    } catch (error) {
      console.error("배너 목록 가져오기 오류:", error);
      return null;
    }
  };
